// src/components/grouptrip/SessionCard.tsx
import React, {useMemo} from "react";
import {motion} from "motion/react";
import {GroupSessionResponse} from "../../models/GroupSessionResponse";
import {CrownIcon} from "../../assets/svgComponents/CrownIcon";

interface SessionCardProps {
    s: GroupSessionResponse;
    isOwner: boolean;
    onOpen: () => void;
    onRemove: (e: React.MouseEvent) => void;
}

const SessionCard: React.FC<SessionCardProps> = ({s, isOwner, onOpen, onRemove}) => {
    const ctaLabel = useMemo(() => {
        if (s.status === "COMPLETED") return "Show results";
        if (s.status === "IN_PROGRESS") return "Preferences";
        return "Start";
    }, [s.status]);

    const ownerText = isOwner ? "You" : "Creator";

    return (
        <motion.li
            layout
            className="snap-start shrink-0 w-[250px] h-[290px] mr-6 last:mr-0"
            initial={{opacity: 0, y: 12}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: 0.22}}
        >
            <div
                onClick={onOpen}
                className="
          relative h-full cursor-pointer rounded-[28px] p-6
          bg-white/60 backdrop-blur
          border border-white
          transition-shadow
          flex flex-col
        "
            >
                {/* Top row: Owner pill + status badge */}
                <div className="inline-flex w-fit items-center gap-2 rounded-full bg-white px-4 py-2 shadow-sm">
                      <span
                          className="inline-flex items-center justify-center w-7 h-7 rounded-full text-white"
                          style={{boxShadow: "0px 0px 15px 0px rgba(186,186,186,0.25)"}}
                      >
                        <CrownIcon/>
                      </span>
                    <span className="text-[15px] font-semibold text-[#232323]">
                        {ownerText}
                      </span>
                </div>


                {isOwner && <button type="button" aria-label={`Delete ${s.name}`}
                    onClick={onRemove} className="absolute top-5 right-4 rounded-full px-2 py-1 text-gray-500 hover:text-red-600">×</button>}
                {/* Title */}
                <div className="mt-6 mb-8">
                    <h3 className="text-[26px] leading-[1.1] font-extrabold tracking-tight text-[#232323] line-clamp-2">
                        {s.name}
                    </h3>
                </div>

                {/* CTA */}
                <div className="mt-auto flex justify-center">
                    <button
                        type="button"
                        onClick={event => { event.stopPropagation(); onOpen(); }}
                        className="
              inline-flex items-center justify-center text-nowrap
              rounded-full px-10 py-3 text-[16px] font-extrabold tracking-[0.1px]
              text-white
              bg-[#A87AF0] hover:brightness-110 active:scale-[0.99]
              transition
            "
                    >
                        {ctaLabel}
                    </button>
                </div>
            </div>
        </motion.li>
    );
};

export default SessionCard;
